module.exports = __webpack_public_path__ + "img/dento_roulette_anime.6841c704.gif";